import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Information Operations · Your Trusted Partner</p>
        <h1>Empower Your Decisions with Insightful Data</h1>
        <p className="lede">
          At Information Operations, we provide cutting-edge solutions that transform data into actionable insights. Explore our services and discover how we can help you navigate the complexities of information management.
        </p>
        <div className="cta-row">
          <a href="/services" target="_self">
            Explore Our Services
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Data-Driven Strategies</h2>
          <p>
            Leverage our expertise to develop strategies that harness the power of data, ensuring your organization stays ahead in a competitive landscape.
          </p>
        </article>
        <article>
          <h2>Tailored Solutions</h2>
          <p>
            We understand that every business is unique. Our customized solutions are designed to meet your specific needs and objectives.
          </p>
        </article>
        <article>
          <h2>Continuous Support</h2>
          <p>
            Our commitment to your success doesn’t end at implementation. We offer ongoing support and insights to help you adapt and thrive.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;